import { useState, useEffect } from "react";
import UserModal from "../../components/Modals/UserModal";
import Swal from 'sweetalert2';
import config from '../../../config';


const UserManagement = () => {

    const [usersData, setUsersData] = useState([]);
    const [loading, setLoading] = useState(false);


    const itemsPerPage = 10;

    const [filterRole, setFilterRole] = useState("All");
    const [currentPage, setCurrentPage] = useState(1);

    // For UserModal 
    const [showUserModal, setShowUserModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const openAddModal = () => {
        setSelectedUser(null);   // Add mode
        setShowUserModal(true);
    };

    const closeModal = () => {
        setShowUserModal(false);
    };

    useEffect(() => {
        fetchUsers();
    }, []);


    //fetch users function
    const fetchUsers = async () => {
        try {
            setLoading(true);

            const response = await fetch(
                `${config.apiBaseUrl}/users/get-users.php`
            );

            const result = await response.json();

            if (!response.ok) {
                Swal.fire("Error", result.message || "Failed to load users", "error");
                return;
            }

            setUsersData(result.data); // <-- API users

        } catch (error) {
            console.error("Fetch users error:", error);
            Swal.fire("Error", "Server error while loading users", "error");
        } finally {
            setLoading(false);
        }
    };


    //Modified for API
    const handleSubmit = async ({ email, role }) => {
        try {
            const response = await fetch(
                `${config.apiBaseUrl}/create-user.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email, role }),
                }
            );

            const result = await response.json();

            if (!response.ok) {
                Swal.fire(
                    "Error",
                    result.message || "Failed to create user",
                    "error"
                );
                return;
            }

            Swal.fire(
                "User Created",
                "User has been created with default password",
                "success"
            );
            fetchUsers(); // <-- reload users
            setShowUserModal(false);

        } catch (error) {
            console.error("Create user error:", error);
            Swal.fire(
                "Error",
                "Server error while creating user",
                "error"
            );
        }
    };


    //***End-UserModal */

    // Reset page when filter changes
    useEffect(() => {
        setCurrentPage(1);
    }, [filterRole]);

    const filteredUsers =
        filterRole === "All"
            ? usersData
            : usersData.filter(u => u.role === filterRole);

    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        return (
            <div className="d-flex justify-content-center align-items-center gap-2 flex-nowrap">
                {/* Previous */}
                <button
                    className="btn btn-sm btn-outline-primary"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    Previous
                </button>

                {/* Current Page */}
                <button className="btn btn-sm btn-primary">
                    {currentPage}
                </button>

                {/* Next Page Number (if exists) */}
                {currentPage + 1 <= totalPages && (
                    <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setCurrentPage(currentPage + 1)}
                    >
                        {currentPage + 1}
                    </button>
                )}

                {/* Dots if more pages */}
                {currentPage + 2 <= totalPages && (
                    <span className="px-1">...</span>
                )}

                {/* Next */}
                <button
                    className="btn btn-sm btn-outline-primary"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    Next
                </button>
            </div>
        );
    };



    return (
        <>
         <div className="row">
            <div className="col-xl-12">
                <div className="card">
                    {/* Header with Role Filters */}
                        <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
                            <div className="btn-group mb-2 mb-md-0">
                                {["All", "Admin", "Teacher", "Staff", "Student"].map(role => (
                                    <button
                                        key={role}
                                        className={`btn btn-sm ${filterRole === role ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => setFilterRole(role)}
                                    >
                                        {role}
                                    </button>
                                ))}
                            </div>

                            <div>
                                <button
                                    className="btn btn-success btn-sm"
                                    onClick={fetchUsers}
                                >
                                    Refresh
                                </button>
                                <span className="p-1"></span>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={openAddModal}
                                >
                                    Add New +
                                </button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Role</th>
                                            <th>Email</th>
                                            <th>Status</th>
                                            <th>Last Login</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4">
                                                        Loading users...
                                                    </td>
                                                </tr>
                                            ) : paginatedUsers.length === 0 ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4">
                                                        No users found
                                                    </td>
                                                </tr>
                                            ) : (
                                                paginatedUsers.map((user, idx) => (
                                                    <tr key={user.id}>
                                                        <td>{startIndex + idx + 1}</td>
                                                        <td>{user.name}</td>
                                                        <td>{user.role}</td>
                                                        <td>{user.email}</td>
                                                        <td>
                                                            <span
                                                                className={`badge ${
                                                                    user.status === "Active"
                                                                        ? "bg-success"
                                                                        : "bg-danger"
                                                                }`}
                                                            >
                                                                {user.status}
                                                            </span>
                                                        </td>
                                                        <td>{user.lastLogin}</td>
                                                        <td>{(() => {
                                                                    const isAdmin = user.role === "Admin";

                                                                    return (
                                                                    <>
                                                                        <button
                                                                        className="btn btn-sm btn-warning me-1"
                                                                        disabled={isAdmin}
                                                                        title={isAdmin ? "Admin account cannot be modified" : ""}
                                                                        >
                                                                        Reset
                                                                        </button>

                                                                        {user.status === "Active" ? (
                                                                        <button
                                                                            className="btn btn-sm btn-danger"
                                                                            disabled={isAdmin}
                                                                            title={isAdmin ? "Admin account cannot be modified" : ""}
                                                                        >
                                                                            Deactivate
                                                                        </button>
                                                                        ) : (
                                                                        <button
                                                                            className="btn btn-sm btn-success"
                                                                            disabled={isAdmin}
                                                                            title={isAdmin ? "Admin account cannot be modified" : ""}
                                                                        >
                                                                            Activate
                                                                        </button>
                                                                        )}
                                                                    </>
                                                                    );
                                                        })()}   
                                                    </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>

                                </table>
                            </div>

                            {/* Pagination */}
                            <div className="d-flex justify-content-center gap-1 mt-3">
                                {renderPagination()}
                            </div>
                        </div>
                </div>
            </div>
        </div>

        {/* UserModal - to add/edit  */}
        <UserModal
            show={showUserModal}
            onClose={closeModal}
            onSubmit={handleSubmit}
            user={selectedUser}
        />

        </>
    );
};

export default UserManagement;
